module.exports = __webpack_public_path__ + "static/media/km-promedio-cada-10000.d3dfa5a1.svg";